import React from 'react';
import { motion } from 'framer-motion';
import { FiMail, FiInstagram } from 'react-icons/fi';
import './Contact.css';

const revealVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

const Contact = () => {
  return (
    <section id="contact" className="section contact">
      <motion.h2
        className="section-heading"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={revealVariants}
      >
        Contact
      </motion.h2>

      <motion.p
        className="contact-lead"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={revealVariants}
      >
        Want to get in touch? Reach out on social or send an email.
      </motion.p>

      <motion.div
        className="contact-links"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={revealVariants}
      >
        <a
          className="contact-link"
          href="mailto:ajaysingh7161@gmail.com"
          aria-label="Email Ajay Singh"
        >
          <FiMail />
          <span>Email</span>
        </a>
        <a
          className="contact-link"
          href="https://www.instagram.com/floppyflicks/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ajay Singh on Instagram"
        >
          <FiInstagram />
          <span>Instagram</span>
        </a>
      </motion.div>
    </section>
  );
};

export default Contact;
